module.exports = __webpack_public_path__ + "media/images/athletes/2133-f393fd04ecd5511fe49172b016d44f08.png";